export function newProjectUrl(project: {
    id: string | null;
    customUrl?: string | null;
}) {
    if (project.customUrl && project.customUrl != '') {
        return `/new/${project.customUrl}`;
    }

    return `/new/${project.id ?? '_'}`;
}

export default function projectUrl(project: {
    id: string | null;
    customUrl?: string | null;
}) {
    if (project.customUrl && project.customUrl != '') {
        return `/project/${project.customUrl}`;
    }

    return `/project/${project.id ?? '_'}`;
}

// The query param that opens a tab full screen (?fullscreen=1).
export const fullscreenParam = 'fullscreen';

// A link to one tab of a project, optionally full screen. tabName is a slot
// name from ProjectTabNames ('project', 'tab2'...'tab5') rather than the tab's
// title, so the link keeps working when the tab is renamed. Full screen only
// takes effect on tab types that support it; elsewhere the page ignores it.
export function projectTabUrl(
    project: {id: string | null; customUrl?: string | null},
    tabName?: string | null,
    options: {fullscreen?: boolean} = {}
) {
    const params = new URLSearchParams();
    if (tabName) {
        params.set('tab', tabName);
    }
    if (options.fullscreen) {
        params.set(fullscreenParam, '1');
    }

    const query = params.toString();
    return projectUrl(project) + (query ? `?${query}` : '');
}
